<template>
  <div class="vehicle-usages" v-if="vehicle">
    <report-usages-list show-no-energy :vehicle-id="vehicle.id" />
  </div>
</template>

<script>
import ReportUsagesList from "@/components/elements/ReportUsagesList.vue";

export default {
  components: { ReportUsagesList },

  computed: {
    vehicle() {
      return this.$parent.vehicle ?? null
    },
  },
}
</script>

<style lang="scss">
</style>
